import { IUser, UserSource } from 'common/schema/User';
import { CitizenNationality } from './Citizen';
import { IRequest } from './request/Request';

export class UserLogic {
  static canLogout(user: IUser | null) {
    if (user?.originalStrategy === 'jwt') return true;
    if (user?.originalStrategy === 'saml') return true;
    if (user?.originalStrategy === 'openweb') return true;

    return false;
  }

  /**
   * Controlla se l'utente è stato registrato via email, poiché sono gli unici
   * che possono modificare il profilo
   */
  static canEditProfile(user: IUser | null) {
    if (!user) return false;
    return user.source === UserSource.EmailRegistration;
  }

  /**
   * Mail per l'invio della notifica (ricevuta).
   * Utilizziamo di default il "mittente" impostato nella domanda.
   * In caso sia nullo, usiamo invece l'email del cittadino
   * usata al momento della registrazione.
   */
  static recipientMailForRequest(
    citizen: Maybe<{ email?: string | null }>,
    request: Maybe<IRequest>
  ) {
    if (!request) return null; // Caricamento

    return request.authorMail ?? citizen?.email;
  }

  /**
   * Gli utenti non extra-europei (italiani, EU) con un account email non possono inviare una richiesta.
   * Per gli utenti EU è necessario il login con un TrustedSSO.
   * In caso di utenti anonimi, ritorna vero.
   */
  static nationalityAllowsSending(user: IUser | null, sendRightNow: boolean) {
    if (!user) return true;
    return (
      user.source !== UserSource.EmailRegistration ||
      user.citizen?.nationality === CitizenNationality.ExtraEU ||
      !sendRightNow
    );
  }
}
